import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import OriginalSlider from './OriginalSlider';
import originalsInit from './redux/originalsInit';

export const getOriginalSliderWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  viewComponent: OriginalSlider,
  initActionsCreator: originalsInit,
});

